export default __webpack_public_path__ + "static/media/waving-hand-emoji.be6abb0a.png";